import React, { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CircularProgress, Box, Typography } from '@mui/material';

import {
  Grid,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Button,
  IconButton,
  MenuItem,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import Sidebar from "../../components/Sidebar";

const categoryOptions = ["General", "Backward", "Reserved"];
const typeOptions = ["Tuition Fees", "Special Fees", "Transport Fees"];
const statusOptions = ["Class 1", "Class 2"];

export default function FeeStructure() {
  const [rows, setRows] = useState([]);
  const state = useSelector((state) => state);
  console.log('DBG::state: ' . state);

  const addRow = () => {
    setRows([
      ...rows,
      {
        id: Date.now(),
        category: "",
        type: "",
        status: "",
        priority: 0,
        dateRanges: [],
      },
    ]);
  };

  const updateRow = (id, field, value) => {
    setRows(
      rows.map((row) =>
        row.id === id ? { ...row, [field]: value } : row
      )
    );
  };

  const deleteRow = (id) => {
    setRows(rows.filter((r) => r.id !== id));
  };

  const auth = state.auth; 
  const user = auth?.user; // Optional chaining prevents crashes if auth itself is missing

  // 2. CRITICAL: Guard against null user data
  if (!user) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        {/* If it's just loading, show a spinner. Otherwise, show an error */}
        {auth?.isLoading ? <CircularProgress /> : <Typography>Please log in to view this page.</Typography>}
      </Box>
    );
  }

  return (
    <Paper style={{ padding: '75px 20px 20px 116px' }}>
      <Fragment>
      <Sidebar />
      <Button
        variant="contained"
        color="primary"
        onClick={addRow}
        style={{ marginBottom: 20 }}
      >
        Add Row
      </Button>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Category</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Class</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Start Date</TableCell>
            <TableCell>Last Date</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell>
                <TextField
                  select
                  fullWidth
                  value={row.category}
                  onChange={(e) =>
                    updateRow(row.id, "category", e.target.value)
                  }
                >
                  {categoryOptions.map((o) => (
                    <MenuItem key={o} value={o}>
                      {o}
                    </MenuItem>
                  ))}
                </TextField>
              </TableCell>

              <TableCell>
                <TextField
                  select
                  fullWidth
                  value={row.type}
                  onChange={(e) =>
                    updateRow(row.id, "type", e.target.value)
                  }
                >
                  {typeOptions.map((o) => (
                    <MenuItem key={o} value={o}>
                      {o}
                    </MenuItem>
                  ))}
                </TextField>
              </TableCell>

              <TableCell>
                <TextField
                  select
                  fullWidth
                  value={row.status}
                  onChange={(e) =>
                    updateRow(row.id, "status", e.target.value)
                  }
                >
                  {statusOptions.map((o) => (
                    <MenuItem key={o} value={o}>
                      {o}
                    </MenuItem>
                  ))}
                </TextField>
              </TableCell>

              <TableCell>
                <TextField
                  type="number"
                  value={row.priority}
                  onChange={(e) =>
                    updateRow(row.id, "priority", Number(e.target.value))
                  }
                />
              </TableCell>

{/*
              <TableCell>
                <TextField
                  multiline
                  rows={4}
                  fullWidth
                  variant="outlined"
                  value={JSON.stringify(row.dateRanges, null, 2)}
                  onChange={(e) => {
                    try {
                      const value = JSON.parse(e.target.value);
                      updateRow(row.id, "dateRanges", value);
                    } catch {
                      // ignore invalid JSON while typing
                    }
                  }}
                />
              </TableCell>
*/}

        <TableCell>
            <TextField
              fullWidth
              type="date"
              label="Begin"
              InputLabelProps={{ shrink: true }}
              value="2026-06-06"
            />
        </TableCell>

        <TableCell>
            <TextField
              fullWidth
              type="date"
              label="Last"
              InputLabelProps={{ shrink: true }}
              value="2026-06-09"
            />
        </TableCell>


              <TableCell>
                <IconButton
                  color="secondary"
                  onClick={() => deleteRow(row.id)}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Fragment>
    </Paper>
  );
}
